<h4 [class.small]="small">
  {{ title }} <span class="label label-orange" *ngIf="soon">SOON</span>
  <ng-container *ngIf="permission">
    <app-pro-tag
      [permission]="permission"
      *ngIf="'!' + permission | permissions : gallery"
      [tenantId]="gallery['tenant']?.['id'] || gallery['tenant']"
    ></app-pro-tag>
  </ng-container>
</h4>
<p class="standard-text" [class.small]="small">
  <ng-content></ng-content>
</p>
